import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import Branches from '../../Api/Branches';
import WebTemplateApi from '../../Api/WebTemplateApi';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const WebTemplate = () => {

    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [branchDetails, setBranchDetails] = useState([]);
    const [newTemplate, setNewTemplate] = useState({
        masterType: "",
        name: "",
        textContents: "",
        jsonStructure: "",
        insertQuery: "",
        isActive: true,
        isDeleted: false,
    });
    const navigate = useNavigate();

    console.log("data", data);
    console.log("data1", data1);
    console.log("branchDetails", branchDetails);

    const handleEdit = (trans1Data, trans2Data) => {
        navigate(`/Transaction`, {
            state: { trans1: trans1Data, trans2: trans2Data },
        });
        console.log("trans1Data", trans1Data);
        console.log("trans2Data", trans2Data);
        console.log(`Edit item with id ${data.id}`);
    };

    const handleDelete = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Are you sure you want to delete this template?",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes delete it !!",
                width: "300px",
                customClass: {
                    title: "swal2-custom-title",
                    confirmButton: "my-confirm-button",
                    cancelButton: "my-cancel-button",
                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

            if (result.isConfirmed) {
                const response = await WebTemplateApi.DeleteTemplate(id)
                if (response.StatusCode === 200) {
                    await Swal.fire({
                        title: "Deleted!!",
                        text: "Template has been deleted successfully.",
                        icon: "success",
                        confirmButtonText: "Okay",
                        width: "300px",
                        customClass: {
                            title: "swal2-custom-title",
                            confirmButton: "my-confirm-button",
                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                        },
                    });
                    fetchBranches()
                    fetchTransactions();
                    fetchTransactions2();
                }
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Error",
                text: error?.message || "Failed to delete template.",
                icon: "error",
                width: "300px",
            });
        }
    };

    const handleInsertTemplate = async () => {
        const masterType = Number(newTemplate.masterType);
        const name = (newTemplate.name || "").trim();

        if (!masterType || !name) {
            Swal.fire({
                title: "Validation",
                text: "Master Type and Name are required.",
                icon: "warning",
                width: "300px",
            });
            return;
        }

        const payload = {
            ...newTemplate,
            masterType,
            name,
            createdOn: new Date(),
            isActive: Boolean(newTemplate.isActive),
            isDeleted: Boolean(newTemplate.isDeleted),
        };

        try {
            const response = await WebTemplateApi.CreateTemplate(payload);
            if (response?.StatusCode === 201) {
                Swal.fire({
                    title: "Saved",
                    text: "Template inserted successfully.",
                    icon: "success",
                    width: "300px",
                    customClass: {
                        title: "swal2-custom-title",
                        confirmButton: "my-confirm-button",
                        popup: "swal2-custom-popup",
                        htmlContainer: "swal2-custom-text",
                        icon: "swal2-custom-icon",
                    },
                });
                setNewTemplate({
                    masterType: "",
                    name: "",
                    textContents: "",
                    jsonStructure: "",
                    insertQuery: "",
                    isActive: true,
                    isDeleted: false,
                });
                fetchTransactions();
                fetchTransactions2();
            } else {
                Swal.fire({
                    title: "Error",
                    text: response?.ErrorMessages || "Unable to insert template.",
                    icon: "error",
                    width: "300px",
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Error",
                text: "Insert failed.",
                icon: "error",
                width: "300px",
            });
        }
    };

    function formatIsoDate(isoDate) {
        if (typeof isoDate !== 'string' || !isoDate) {
            console.log("Invalid input: Please provide a valid ISO date string.");
            return "";
        }
        // Extract the date part from the ISO string
        return isoDate.substring(0, 10); // Returns "yyyy-MM-dd"
    }

    const fetchTransactions = async () => {
        const response = await WebTemplateApi.GetTemplate()
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }

    useEffect(() => {
        fetchTransactions();
    }, []);


    const fetchTransactions2 = async () => {
        const response = await WebTemplateApi.GetTemplate()
        if (response) {
            console.log("response", response);
            setData1(response.Result)
        }
    }

    useEffect(() => {
        fetchTransactions2();
    }, []);

    const fetchBranches = async () => {
        const response = await Branches.GetAllClients()
        if (response) {
            console.log("response", response);
            setBranchDetails(response.Result)
        }
    }
    useEffect(() => {
        fetchBranches()
    }, []);

    const getBranchByTransactionId = (transactionId) => {
        if (data1.length > 0) {
            const branches = data1.filter(item => item.transaction1Id === transactionId);
            return branches.length > 0 ? branches.map(branch => branch.branchId) : ["Unknown"];
        }
        return ["Unknown"];
    };

    const [imageUrls, setImageUrls] = useState({}); // { [id]: url }

    useEffect(() => {
        async function loadImages() {
            const urls = {};
            for (let item of data) {
                if (item.image && item.image != '') {
                    const url = await WebTemplateApi.GetImage(item.image); // returns blob URL
                    urls[item.image] = url;
                }
            }
            setImageUrls(urls);
        }
        loadImages();
    }, [data]);

    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Web Template List</h2>
                </div>

                <div className="company_info-text-im depart_top">Add Web Template</div>
                <div className="control_radius" style={{ marginBottom: "12px" }}>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        type="number"
                                        value={newTemplate.masterType}
                                        onChange={(e) => setNewTemplate({ ...newTemplate, masterType: e.target.value })}
                                        required
                                    />
                                    <label className="modify_p_text2">Master Type *</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        type="text"
                                        value={newTemplate.name}
                                        onChange={(e) => setNewTemplate({ ...newTemplate, name: e.target.value })}
                                        required
                                    />
                                    <label className="modify_p_text2">Name *</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <textarea style={{ minHeight: "90px" }}
                                        className="modify_im_input mode_category1"
                                        value={newTemplate.textContents}
                                        onChange={(e) => setNewTemplate({ ...newTemplate, textContents: e.target.value })}
                                        rows={3}
                                    />
                                    <label className="modify_p_text2">Text Content</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <textarea style={{ minHeight: "90px" }}
                                        className="modify_im_input mode_category1"
                                        value={newTemplate.jsonStructure}
                                        onChange={(e) => setNewTemplate({ ...newTemplate, jsonStructure: e.target.value })}
                                        rows={3}
                                    />
                                    <label className="modify_p_text2">Json Structure</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        type="text"
                                        value={newTemplate.insertQuery}
                                        onChange={(e) => setNewTemplate({ ...newTemplate, insertQuery: e.target.value })}
                                    />
                                    <label className="modify_p_text2">Insert Query</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        <button
                            id="SaveBtnMain"
                            className="save-button-main-save hovered"
                            onClick={handleInsertTemplate}
                        >
                            Insert
                        </button>
                    </div>
                </div>

                <div className="company_info-text-im depart_top">Web Template List</div>
                <div className="control_radius">
                    <div className="table-account-manager">
                        <table className='table-master-acc'>
                            <thead className='header-table-account'>
                                <tr>
                                    <th className='table-header-manager ac-sno-wth'>S.No</th>
                                    <th className='table-header-manager'>Master Type</th>
                                    <th className='table-header-manager'>Name</th>
                                    <th className='table-header-manager'>Text Content</th>
                                    <th className='table-header-manager'>Json Structure</th>
                                    <th className='table-header-manager'>Image</th>
                                    <th className='table-header-manager'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((item, idx) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            <td className='table-data-account'>{(item.masterType)}</td>
                                            <td className='table-data-account'>{item.name}</td>
                                            <td
                                                className='table-data-account'
                                                title={item.textContents}
                                                style={{
                                                    maxWidth: "220px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {item.textContents}
                                            </td>
                                            <td
                                                className='table-data-account'
                                                title={item.jsonStructure}
                                                style={{
                                                    maxWidth: "220px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {item.jsonStructure}
                                            </td>
                                            <td className='table-data-account'>
                                                {imageUrls[item.image] ? (
                                                    <img src={imageUrls[item.image]} alt="template" />
                                                ) : (
                                                    "No Image"
                                                )}
                                            </td>
                                            <td className='table-data-account'>
                                                {/* <button className="edit-btn-acc" onClick={() => handleEdit(item, relatedTrans2Data)}><Icon icon="lucide:edit" /></button> */}
                                                <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                            </td>
                                        </tr>
                                    )
                                }
                                )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebTemplate;
